import ProductSummary from './ProductSummary';

export default ProductSummary;
